export default "__VITE_ASSET__BKTAKS5x__"